import { Layout } from "@singularsystems/neo-canvas-grid";
import { IGridLayout } from "@singularsystems/neo-canvas-grid/dist/Grid/Misc/Layouts";
import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, DateSelectionComponent } from "@singularsystems/neo-reporting";
import IssuerInvestmentAutoComplete from "../../../Domain/Components/IssuerInvestmentAutoComplete";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { ReportCategory } from "../ReportCategory";
import InvestorDividendCriteria from "./InvestorDividendCriteria";
import { DataCacheEntry } from "@singularsystems/neo-core/dist/Data";
import Entity from "../../../Domain/Models/Catalogue/Investments/Entity";

@NeoReport("InvestorDividend", { category: ReportCategory.InvestorReports })
export default class InvestorDividendReport extends Report<InvestorDividendCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(InvestorDividendCriteria);
    }

    public renderCriteria() {
        return InvestorDividendReport.renderReportCriteria(this.criteria, this.dataCache.entities);
    }

    public static renderReportCriteria(criteria: InvestorDividendCriteria, entities: DataCacheEntry<Entity[]>, includeIssuerInvestment: boolean = true) {
        return <div>
            <DateSelectionComponent criteria={criteria} />
            <Neo.GridLayout md={2} lg={3}>
                <div>
                    <Neo.FormGroup bind={criteria.meta.entityId} select={{ itemSource: entities }} />
                    {includeIssuerInvestment &&
                        <Neo.FormGroup>
                            <IssuerInvestmentAutoComplete
                                bind={criteria.meta.issuerInvestmentId}
                                bindDisplay={criteria.meta.issuerInvestmentName}
                                entityId={criteria.entityId}
                                useParentCache={true} />
                        </Neo.FormGroup>}
                </div>
            </Neo.GridLayout>
        </div>;
    }

    public getDefaultGridLayout(criteria?: InvestorDividendCriteria | undefined, propertyKey?: string | undefined): IGridLayout | undefined {
        return {
            "root": {
                "headerLines": 2,
                "columns": [
                    {
                        "key": "refNo",
                        "width": 70
                    },
                    {
                        "key": "investorInvestmentId",
                        "sortDirection": 0
                    },
                    {
                        "key": "issuerInvestmentId",
                        "width": 100
                    },
                    {
                        "key": "investorName",
                        "width": 300
                    },
                    {
                        "key": "linkedRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "investmentRate",
                        "suppressTotal": true
                    },
                    {
                        "key": "investmentIdChild",
                        "visible": false
                    },
                    {
                        "key": "dividend.dividendDate",
                        "formatString": "dd MMM yyyy (ddd)",
                        "width": 140
                    },
                    {
                        "key": "netRate",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "avgCapital"
                        }
                    },
                    {
                        "key": "netPercOfPrime",
                        "total": {
                            "type": "weightedAverage",
                            "relatedColumn": "avgCapital"
                        }
                    }
                ],
                "columnOrder": [
                    "refNo",
                    "investorInvestmentId",
                    "issuerInvestmentId",
                    "investorName",
                    "registrationNo",
                    "linkedRate",
                    "investmentRate",
                    "amount",
                    "investmentIdChild",
                    "avgCapital",
                    "dividend.dividendDate",
                    "dividend.paidDate",
                    "legalEntity",
                    "entityCompanyName",
                    "contributionDate",
                    "redemptionDate",
                    "withHoldTax",
                    "rateGrossedUp",
                    "dividend.dividendAmount",
                    "dividend.processedAmount",
                    "dividend.dividendTax",
                    "dividend.netAmount",
                    "dividend.paidAmount",
                    "netRate",
                    "netPercOfPrime",
                    "externalAccountNo",
                    "productType",
                    "commissionDiv",
                    "commissionType"
                ]
            }
        } as Layout.IGridLayout;
    }
}